import {useEffect, useRef, useState} from "react";
import Agendas from "./Agendas";
import {StockImage} from "../Brand.tsx";
import { UseAPICaller } from "../../apiCaller.tsx";

import "../../css/AppDialog.css";

import { SurveyListData } from "./FormDataTypes.tsx";
import { InfoIcon } from "../AppDialog.tsx";

export interface AppDialogProps {
  isOpen: boolean;
  onDialogClose?: () => void;
}


const ActivityDialogContent : React.FC<AppDialogProps> = ({isOpen, onDialogClose}) => {
    // const {GetEditableActivityInfoFromId, UpdateActivityInfo, GetSurveysList, DeleteResource, FinishResource} = UseJsonApi();
    const {GetEditableActivityInfo, GetSurveys, UpdateActivity, DeleteResource, UploadActivityThumbnail} = UseAPICaller();

    const [activityData, setActivityData] = useState<{title:string|null, type:string|null, startDate:string|null, endDate:string|null, description:string|null, agendas:[], surveys: number[], attendees:number|null, finished:boolean, thumbnailPath:string}>({title:"", type:"", startDate:"", endDate:"", description:"", agendas:[], surveys: [], attendees:0, finished:false, thumbnailPath:""});
    const [surveys, setSurveys] = useState<SurveyListData[]>([]);

    const GetActivityData = async () =>{
        const activityId = +sessionStorage.getItem("activityId");
        if (activityId) 
        {
            const data = await GetEditableActivityInfo(activityId);
            setActivityData(data);
        }
    }

    useEffect(() => {
            if (!isOpen) return;
    
            const GetSurveysFromDB = async () => {
                const company = JSON.parse(sessionStorage.getItem("company"));
                if (company) 
                {
                    const surveys = await GetSurveys(company.companyId);
                    setSurveys(surveys);
                }
            }

            
            GetSurveysFromDB();
            GetActivityData();
            
        }, [isOpen]);

    const OnAgendaChange = (newSelected: []) => {
        setActivityData(prev => ({ ...prev, agendas: newSelected }));
    }

    const handleChange = (newData) => {
        setActivityData((prev) => ({ ...prev, ...newData }));
    };

    const handleSurveyToggle = (id: number) => {
        setActivityData((prev) => {
            const alreadySelected = prev.surveys.includes(id);
            const updatedSurveys = alreadySelected
                ? prev.surveys.filter((sid) => sid !== id)
                : [...prev.surveys, id];

            return { ...prev, surveys: updatedSurveys };
        });
    };

    const OnSave = () => {
        const activityId = +sessionStorage.getItem("activityId");
        if (activityId) 
        {
            UpdateActivity(activityId, activityData);
        }
    };

    const OnFinishActivity = () => {
        const activityId = +sessionStorage.getItem("activityId");
        setActivityData({...activityData, finished:true});
        UpdateActivity(activityId, {finished:true});
    }

    const OnDelete = () => {
        if (window.confirm("Are you sure that you want to delete this activity? \nThis is not reversable.")) {
            const activityId = +sessionStorage.getItem("activityId");
            if (activityId) 
            {
                DeleteResource("activities", activityId);
                if(onDialogClose)
                    onDialogClose();
            }
        }
    };

    const fileInputRef = useRef<HTMLInputElement | null>(null);
    
    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const activityId = +sessionStorage.getItem("activityId");

        const res = await UploadActivityThumbnail(activityId, file);

        if(res)
        {
            if (fileInputRef.current) 
                fileInputRef.current.value = '';
            GetActivityData();
        }
    };

    const onUploadImage = () => {
        fileInputRef.current?.click();
    };
    
    return (
        <div className="dialog-body">
            <div className="dialog-column-left">
                <div style={{display:"flex", flexDirection:"column", gap:6}}>
                    <button className="dialog-button save-button" onClick={OnSave} style={{borderStyle:"solid"}}>Save</button>
                    <button className={`dialog-button ${activityData.finished ? "inactive-button" : "blue-button"}`} onClick={OnFinishActivity}>{activityData.finished ? "Activity finished" : "Set as finished"}</button>
                    {/* <button className="dialog-button blue-button" onClick={() => alert("Export to PDF comming soon")}>Export PDF</button> */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />
                    <button className="dialog-button blue-button" onClick={onUploadImage}>{"Upload Cover (Max. 2mb)"}</button>
                </div>
                <div style={{marginTop:"auto"}}>
                    <button className="dialog-button red-button" onClick={OnDelete}>Delete</button>
                </div>
            </div>
            <div className="dialog-column-middle">
                <div style={{display:"flex", gap:16}}>
                    <div style={{display:"flex", flexDirection:"column", gap:16}}>
                        <div style={{display:"flex", flexDirection:"column"}}>
                            <label style={{}}>Title</label>
                            <input type="text" value={activityData.title} onChange={e => handleChange( {title: e.target.value})} placeholder="Activity name..." style={{width:"60%"}}></input>
                        </div>
                        <div style={{display:"flex", flexDirection:"column"}}>
                            <div style={{display:"flex", paddingTop:"3px"}}>
                                <label>Type</label>
                                <InfoIcon text={"What kind of activity that this is. Ex. Social gathering, music festival, or a public presentation."}/>
                            </div>
                            <input type="text" value={activityData.type} onChange={e => handleChange( {type: e.target.value})} placeholder="Activity type" style={{width:"60%"}}></input>
                        </div>
                        <div>
                            <label>Select dates</label>
                            <div>
                                <input type="date" value={activityData.startDate} onChange={e => handleChange( {startDate: e.target.value})}></input>
                                <i className="fa fa-long-arrow-right"></i>
                                <input type="date" value={activityData.endDate} onChange={e => handleChange( {endDate: e.target.value})}></input>
                            </div>
                        </div>
                        <div style={{display:"flex", flexDirection:"column"}}>
                            <label>Number of Participants</label>
                            <input type="number" value={activityData.attendees} onChange={e => handleChange( {attendees: e.target.value})} placeholder="Activity type" style={{minWidth:50, maxWidth:80}}></input>
                        </div>
                    </div>
                    
                    <div style={{display:"flex", flexDirection:"column"}}>
                        <label>Cover</label>
                        {activityData.thumbnailPath ? <img className="activity-thumbnail" src={`http://185.7.62.58:5000/${activityData.thumbnailPath}`} alt="Image"></img> : <span>No cover image</span>}
                    </div>
                </div>
                <div style={{display:"flex", flexDirection:"column"}}>
                    <label>Description</label>
                    <textarea style={{width:"100%", minHeight:150, resize:"vertical", maxHeight:200}} value={activityData.description} onChange={e => handleChange( {description: e.target.value})}></textarea>
                </div>
            </div>
            <div className="dialog-column-right">
                <Agendas selected={activityData.agendas} onChange={OnAgendaChange} size={70}/>
                <div>
                    <div style={{display:"flex", paddingTop:"3px"}}>
                        <label>Surveys</label>
                        <InfoIcon text={"Select any survey that is connected with this activity. More than one can be selected."}/>
                    </div>
                    <hr></hr>
                    <div className="survey-list">
                        {surveys.map((survey) => (
                            <label key={survey.id} className="survey-item">
                                <span className="survey-title">{survey.title}</span>
                                <input
                                    type="checkbox"
                                    checked={activityData.surveys.includes(survey.id)}
                                    onChange={() => handleSurveyToggle(survey.id)}
                                />
                            </label>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ActivityDialogContent;